<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">{{ title }}</div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <div class="form-label">Period od</div>
            <app-calendar [isNgModel]="true"
                          [(ngModel)]="fromDate"
                          [ngModelOptions]="{standalone:true}"></app-calendar>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="form-label">Period do</div>
            <app-calendar [isNgModel]="true"
                          [(ngModel)]="toDate"
                          [ngModelOptions]="{standalone:true}"></app-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="!fromDate || !toDate">Potvrdi</button>
    </div>
  </div>
</div>